export const GET_SINGLE_BILL_START = 'GET_SINGLE_BILL_START';
export const GET_SINGLE_BILL_ERROR = 'GET_SINGLE_BILL_ERROR';
export const GET_SINGLE_BILL_SUCCESS = 'GET_SINGLE_BILL_SUCCESS';
